import styled from "styled-components";

export const Text = styled.div`
  font-weight: 400;
  font-size: 15px;
  line-height: 33px;
  color: #fff;
`;
